import { DashboardSummary } from "../../types";

export const RIEPILOGO_VUOTO: DashboardSummary = {
  mancanti: 0,
  validi: 0,
  scaduti: 0,
  inScadenza1m: 0,
  inScadenza2m: 0,
  inScadenza6m: 0,
};

// Il conteggio degli attestati in scadenza nella finestra scelta dall'utente
// (1, 2 o 6 mesi); zero per una finestra che il riepilogo non prevede.
export function conteggioInScadenza(
  riepilogo: DashboardSummary,
  mesi: number
): number {
  switch (mesi) {
    case 1:
      return riepilogo.inScadenza1m;
    case 2:
      return riepilogo.inScadenza2m;
    case 6:
      return riepilogo.inScadenza6m;
    default:
      return 0;
  }
}
